import { render, staticRenderFns } from "./UploadDrop.vue?vue&type=template&id=f1ce7962&scoped=true&"
import script from "./UploadDrop.vue?vue&type=script&lang=js&"
export * from "./UploadDrop.vue?vue&type=script&lang=js&"
import style0 from "./UploadDrop.vue?vue&type=style&index=0&id=f1ce7962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ce7962",
  null
  
)

export default component.exports